var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2513 6.41667L9.16797 4.5V12.5C9.16797 13 9.5013 13.3333 10.0013 13.3333C10.5013 13.3333 10.8346 13 10.8346 12.5V4.5L12.7513 6.41667C13.0846 6.75 13.5846 6.75 13.918 6.41667C14.2513 6.08333 14.2513 5.58333 13.918 5.25L10.5846 1.91667C10.5013 1.83333 10.418 1.75 10.3346 1.75C10.168 1.66667 9.91797 1.66667 9.66797 1.75C9.58464 1.75 9.5013 1.83333 9.41797 1.91667L6.08464 5.25C5.7513 5.58333 5.7513 6.08333 6.08464 6.41667C6.41797 6.75 6.91797 6.75 7.2513 6.41667ZM17.5013 11.6667C17.0013 11.6667 16.668 12 16.668 12.5V15.8333C16.668 16.3333 16.3346 16.6667 15.8346 16.6667H4.16797C3.66797 16.6667 3.33464 16.3333 3.33464 15.8333V12.5C3.33464 12 3.0013 11.6667 2.5013 11.6667C2.0013 11.6667 1.66797 12 1.66797 12.5V15.8333C1.66797 17.25 2.7513 18.3333 4.16797 18.3333H15.8346C17.2513 18.3333 18.3346 17.25 18.3346 15.8333V12.5C18.3346 12 18.0013 11.6667 17.5013 11.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportData);
export default __webpack_public_path__ + "static/media/ExportData.1d8c4fd96afcae0183c2f3e7493baf6a.svg";
export { ForwardRef as ReactComponent };